export const FEATURE_FLAGS = {
  STATION_VIEW: "featureFlagStationView",
  VDA_ACTIONS: "featureFlagVdaActions",
  QUEUE_MANAGER: "featureFlagQueueManager",
  LIVE_MISSIONS: "featureFlagLiveMissions",
} as const;

export type FeatureFlagKey = keyof typeof FEATURE_FLAGS;
